import { Button } from '@edsn/pie-components';
import WarningIcon from '@iconify/icons-material-symbols/verified-user-outline';
import { format } from 'date-fns';
import { useAtomValue } from 'jotai';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useGetCprManagementContacts } from '#pie/internal/api/pie-bff';
import { emptyFilterAtom } from '#pie/stores/searchOnlyFilter';
import { Icon } from '../icon/Icon';
import { VerifyDataModal } from '../verify-data-modal/VerifyDataModal';

export const VerifyDataButton = () => {
  const { t } = useTranslation();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const filters = useAtomValue(emptyFilterAtom);

  const { data } = useGetCprManagementContacts({
    pagination: { pageIndex: 0, pageSize: 100 },
    filter: filters,
  });

  const organisationId = data?.items?.[0]?.organisation
    ? data.items[0].organisation.id
    : '';

  const lastVerified = data?.latestContactValidationDate
    ? new Date(data.latestContactValidationDate)
    : null;

  const validationDate = lastVerified
    ? format(new Date(lastVerified), 'dd MMMM yyyy')
    : 'Onbekend';

  return (
    <>
      <Button
        onClick={() => setIsModalOpen(true)}
        iconStart={
          <Icon
            icon={WarningIcon}
            className="text-action-secondary-enabled flex items-center"
          />
        }
        action="tertiary"
        emphasis="subtle"
        className="px-4"
      >
        {t('cpr_management_group.button.verify')}
      </Button>
      <VerifyDataModal
        open={isModalOpen}
        onOpenChange={setIsModalOpen}
        organisationId={organisationId}
        validationDate={validationDate}
        cprContacts={data?.items || []}
      />
    </>
  );
};
